import React from 'react';
const bonuses = [{
  number: '01',
  icon: '📊',
  title: 'Dashboard Resumen de Clínica',
  value: '$9.000',
  subtitle: 'Vista general de tu clínica en una sola pantalla.',
  description: 'Pacientes activos, turnos del día, stock crítico y vacunaciones pendientes — todo visible de un vistazo cada mañana.'
}, {
  number: '02',
  icon: '📆',
  title: 'Planilla de Recordatorios por WhatsApp',
  value: '$7.000',
  subtitle: 'Los mensajes listos para copiar y pegar.',
  description: 'Plantillas de texto para recordar turnos, vacunas y controles. Ahorrás tiempo y tus clientes lo perciben como un servicio profesional.'
}, {
  number: '03',
  icon: '💰',
  title: 'Control de Ingresos y Egresos',
  value: '$8.000',
  subtitle: 'La caja de tu clínica ordenada sin ser contador.',
  description: 'Registrá cobros, gastos y honorarios. Sabé cuánto facturaste este mes sin abrir ningún sistema contable.'
}, {
  number: '04',
  icon: '📋',
  title: 'Guía de Implementación Rápida',
  value: '$6.000',
  subtitle: 'Cómo implementar el kit en tu clínica en menos de 2 horas.',
  description: 'Paso a paso para cargar tus datos, personalizar las planillas y tener todo funcionando el mismo día que lo descargás.'
}];
export function Bonuses() {
  return <section className="bg-teal py-12 px-6" data-id="element-15">
      <div className="max-w-md mx-auto space-y-8" data-id="element-16">
        <div className="text-center space-y-2" data-id="element-17">
          <h2 className="text-2xl font-bold text-white" data-id="element-18">
            Bonos incluidos. Gratis. Siempre.
          </h2>
          <p className="text-white/80 text-sm" data-id="element-19">
            Valor total: <span className="line-through" data-id="element-20">$36.000 ARS</span> →{' '}
            <span className="font-bold text-lg" data-id="element-21">$0</span> con tu kit.
          </p>
        </div>

        <div className="space-y-4" data-id="element-22">
          {bonuses.map((bonus, index) => <div key={index} className="bg-white rounded-xl p-6 space-y-3 shadow-lg" data-id="element-23">
              <div className="flex items-start justify-between" data-id="element-24">
                <div className="flex items-center gap-3" data-id="element-25">
                  <span className="text-3xl" data-id="element-26">{bonus.icon}</span>
                  <div data-id="element-27">
                    <div className="text-xs text-navy/60 font-semibold" data-id="element-28">
                      BONO {bonus.number}
                    </div>
                    <h3 className="font-bold text-navy" data-id="element-29">{bonus.title}</h3>
                  </div>
                </div>
                <div className="text-right" data-id="element-30">
                  <div className="text-xs text-navy/60 line-through" data-id="element-31">
                    {bonus.value}
                  </div>
                  <div className="text-teal font-bold text-lg" data-id="element-32">GRATIS</div>
                </div>
              </div>

              <p className="text-sm font-semibold text-navy" data-id="element-33">
                {bonus.subtitle}
              </p>

              <p className="text-sm text-navy/70 leading-relaxed" data-id="element-34">
                {bonus.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}